// extracted by mini-css-extract-plugin
export var advancedProductGroup = "style-mod--advanced-product-group--30404";
export var badge = "style-mod--badge--321df";
export var box = "style-mod--box--9f29f";
export var helpGroup = "style-mod--help-group--4734d";
export var helpIcon = "style-mod--help-icon--95a62";
export var linkBox = "style-mod--link-box--285ed";
export var multipleCategories = "style-mod--multiple-categories--d8c94";
export var selected = "style-mod--selected--3f46b";
export var selectedCat = "style-mod--selected-cat--73349";
export var variantImages = "style-mod--variant-images--a24a6";